import React from "react";
import explogo from "../export.png";

export default function Grids() {
  return (
    <div>
      <div
        className="row row-cols-1 row-cols-md-3 g-4"
        style={{ marginRight: "0", marginTop: "4rem ", marginLeft: "2px" }}
      >
        <div className="col">
          <div className="card h-100">
            <img
              src="https://files.porsche.com/filestore/image/multimedia/none/carrange-flyout-718/small/57ad32c8-ca23-11ec-80ef-005056bbdc38;sM;twebp;c892;gc/porsche-small.webp"
              className="card-img-top"
              alt="..."
            />
            <div className="card-img-overlay">
              <h5 className="card-title text-white">718</h5>
              <p className="card-text">
                from <b>INR 14,772,000</b>
              </p>
              <div className="bottom">
                <button className="btn btn-light">
                  <img
                    src={explogo}
                    style={{
                      paddingRight: "4px",
                      width: "25px",
                      marginRight: "3px",
                    }}
                    alt=""
                    className="exp"
                  />
                  Build your Own
                </button>
                <button className="btn btn-light tsp">
                  <span className="ra">&#8250;</span> All models
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img
              src="https://files.porsche.com/filestore/image/multimedia/none/carrange-flyout-911/small/3cf76e8c-6694-11e9-80c4-005056bbdc38;sQ;twebp;c1693;gc/porsche-small.webp"
              className="card-img-top"
              alt="..."
            />
            <div className="card-img-overlay">
              <h5 className="card-title text-white">911</h5>
              <p className="card-text">
                from <b>INR 14,772,000</b>
              </p>
              <div className="bottom">
                <button className="btn btn-light">
                  <img
                    src={explogo}
                    style={{
                      paddingRight: "4px",
                      width: "25px",
                      marginRight: "3px",
                    }}
                    alt=""
                  />
                  Build your Own
                </button>
                <button className="btn btn-light tsp">
                  <span className="ra">&#8250;</span> All models
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img
              src="https://files.porsche.com/filestore/image/multimedia/none/carrange-flyout-taycan/small/094d1c1c-bab0-11e9-80c4-005056bbdc38;sQ;twebp;c1693;gc/porsche-small.webp"
              className="card-img-top"
              alt="..."
            />
            <div className="card-img-overlay">
              <h5 className="card-title text-white">Taycan</h5>
              <p className="card-text">
                from <b>INR 14,772,000</b>
              </p>
              <div className="bottom">
                <button className="btn btn-light">
                  <img
                    src={explogo}
                    style={{
                      paddingRight: "4px",
                      width: "25px",
                      marginRight: "3px",
                    }}
                    alt=""
                  />
                  Build your Own
                </button>
                <button className="btn btn-light tsp">
                  <span className="ra">&#8250;</span> All models
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img
              src="https://files.porsche.com/filestore/image/multimedia/none/carrange-flyout-panamera/small/31077aa2-d337-11ea-80cc-005056bbdc38;sQ;twebp;c1693;gc/porsche-small.webp"
              className="card-img-top"
              alt="..."
            />
            <div className="card-img-overlay">
              <h5 className="card-title text-white">Panamera</h5>
              <p className="card-text">
                from <b>INR 14,772,000</b>
              </p>
              <div className="bottom">
                <button className="btn btn-light">
                  <img
                    src={explogo}
                    style={{
                      paddingRight: "4px",
                      width: "25px",
                      marginRight: "3px",
                    }}
                    alt=""
                  />
                  Build your Own
                </button>
                <button className="btn btn-light tsp">
                  <span className="ra">&#8250;</span> All models
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img
              src="https://files.porsche.com/filestore/image/multimedia/none/carrange-flyout-macan/small/47db3c6d-e3d7-11eb-80d9-005056bbdc38;sM;twebp;c892;gc/porsche-small.webp"
              className="card-img-top"
              alt="..."
            />
            <div className="card-img-overlay">
              <h5 className="card-title text-white">Macan</h5>
              <p className="card-text">
                from <b>INR 14,772,000</b>
              </p>
              <div className="bottom">
                <button className="btn btn-light">
                  <img
                    src={explogo}
                    style={{
                      paddingRight: "4px",
                      width: "25px",
                      marginRight: "3px",
                    }}
                    alt=""
                  />
                  Build your Own
                </button>
                <button className="btn btn-light tsp">
                  <span className="ra">&#8250;</span> All models
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img
              src="https://files.porsche.com/filestore/image/multimedia/none/carrange-flyout-cayenne/small/2fbf4ab0-ded1-11ed-8101-005056bbdc38;sQ;twebp;c1693;gc/porsche-small.webp"
              className="card-img-top"
              alt="..."
            />
            <div className="card-img-overlay">
              <h5 className="card-title text-white">Cayenne</h5>
              <p className="card-text">
                from <b>INR 14,772,000</b>
              </p>
              <div className="bottom">
                <button className="btn btn-light">
                  <img
                    src={explogo}
                    style={{
                      paddingRight: "4px",
                      width: "25px",
                      marginRight: "3px",
                    }}
                    alt=""
                  />
                  Build your Own
                </button>
                <button className="btn btn-light tsp">
                  <span className="ra">&#8250;</span> All models
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p style={{ margin: "2rem 5rem" }}>
        * European specifications shown below. Market specific values to be
        confirmed upon homologation.
      </p>
    </div>
  );
}
